/**
 * Circle Text Animation - Scroll-driven 3D text effect
 * Calculates scroll progress and drives CSS custom properties for the animation
 */
class CircleTextAnimation extends HTMLElement {
  constructor() {
    super();
    this.lastProgress = -1;
    this.rafId = null;
    this.onScroll = this.onScroll.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.updateProgress();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  onScroll() {
    if (this.rafId) return;
    this.rafId = requestAnimationFrame(() => {
      this.updateProgress();
      this.rafId = null;
    });
  }

  updateProgress() {
    if (this.closest('homepage-scroll-story')) return;
    const rect = this.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const sectionTop = rect.top;
    const sectionHeight = this.offsetHeight;

    // Progress 0 = section top at viewport bottom (just entering)
    // Progress 1 = section bottom at viewport top (just left)
    const progress = Math.max(
      0,
      Math.min(1, (viewportHeight - sectionTop) / (viewportHeight + sectionHeight))
    );

    if (Math.abs(progress - this.lastProgress) > 0.0001) {
      this.lastProgress = progress;
      this.style.setProperty('--circle-rotate', progress);
      this.style.setProperty('--circle-delayed-rotate', progress);
    }
  }
}

if (!customElements.get('circle-text-animation')) {
  customElements.define('circle-text-animation', CircleTextAnimation);
}
